import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackingSource", "upgradeData", "offerProductConfigurations", "style", "className", "use", "data-selenium-id", "currencyCode", "children"];
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { REQUEST_ADDITIONAL_SEATS } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import { omit } from '../../utils';
import UICheckoutButton from 'ui-addon-upgrades/button/UICheckoutButton';
import UIButton from 'UIComponents/button/UIButton';
import { useState } from 'react';
import Small from 'UIComponents/elements/Small';
import styled from 'styled-components';
import { upgradeDataPropsInterface } from '../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { AddAdditionalSeatsPropsInterface } from './AddAdditionalSeatsPropsInterface';
import { trackPurchaseMotionFailure } from '../utils/metricUtils';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { BUY_ADDITIONAL_SEATS } from '../purchaseMotions/PurchaseMotionTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledErrorMessage = styled(Small).withConfig({
  displayName: "AddAdditionalSeatsButton__StyledErrorMessage",
  componentId: "sc-1nbypr0-0"
})(["position:absolute;top:0;text-align:center;width:100%;"]);
const AddAdditionalSeatsButton = _ref => {
  let {
      trackingSource,
      upgradeData,
      offerProductConfigurations = [],
      style = {},
      className = '',
      use = 'secondary',
      'data-selenium-id': dataSeleniumId = 'add-additional-seats-button',
      currencyCode,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const handleClick = isValid => {
    tracker.track('addAdditionalSeatsClick', {
      upgradeProduct: upgradeData.upgradeProduct,
      apiName: upgradeData.apiName,
      trackingSource,
      isValid
    });
    if (!isValid) {
      trackPurchaseMotionFailure({
        uniqueId: upgradeData.uniqueId,
        apiName: upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct],
        purchaseMotion: BUY_ADDITIONAL_SEATS
      });
      setIsErrorVisible(true);
    }
  };
  const restWithUpgradeData = Object.assign({}, rest, {
    upgradeData
  });
  const propsToPass = omit(restWithUpgradeData, ['isUpgradePoint', 'trackingSource', 'upgradeData', 'currencyCode', 'canViewNewSeats']);
  const isValid = !!offerProductConfigurations.find(item => {
    const innerConfig = item.productConfigurations;
    return innerConfig.find(productConfigs => {
      return productConfigs.quantity > 0;
    });
  });
  if (!isValid) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
        adminType: TEAM,
        modalType: REQUEST_ADDITIONAL_SEATS,
        upgradeData: upgradeData,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            width: '100%'
          },
          onClick: () => handleClick(false),
          "data-selenium-id": `dummy-${dataSeleniumId}`,
          children: [isErrorVisible && /*#__PURE__*/_jsx(StyledErrorMessage, {
            use: "error",
            "data-selenium-id": `error-${dataSeleniumId}`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pricingCtas.addUsersError"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            className: className,
            use: use,
            style: style,
            children: children || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pricingCtas.buyAdditionalUsers"
            })
          })]
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: TEAM,
    modalType: REQUEST_ADDITIONAL_SEATS,
    upgradeData: upgradeData,
    children: /*#__PURE__*/_jsx(UICheckoutButton, Object.assign({
      "data-selenium-id": dataSeleniumId,
      "data-reagan-primary-cta": true,
      truncate: true,
      onClick: () => handleClick(true),
      disabled: !isValid,
      offerProductConfigurations: offerProductConfigurations,
      className: className,
      use: use,
      style: style,
      upgradeData: upgradeData,
      currencyCode: currencyCode
    }, propsToPass, {
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pricingCtas.buyAdditionalUsers"
      })
    }))
  });
};
AddAdditionalSeatsButton.propTypes = Object.assign({}, upgradeDataPropsInterface, AddAdditionalSeatsPropsInterface, {
  children: PropTypes.node
});
export default AddAdditionalSeatsButton;